import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { genericFormI } from 'src/app/util/interfaces/genericFormRMK';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class TaskCustomFieldService {
	private getTaskCustomFieldUrl = environment.baseApiUrl + 'register/taskCustomField';
	private postTaskCustomFieldUrl = environment.baseApiUrl + 'register/taskCustomField';
	private putTaskCustomFieldUrl = environment.baseApiUrl + 'register/taskCustomField';
	private deleteTaskCustomFieldUrl = environment.baseApiUrl + 'register/taskCustomField';

	constructor(
		private http: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	postTaskCustomField(filters: object, data: genericFormI): Observable<genericFormI> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		let parameters = new HttpParams();

		for (const key of Object.keys(filters)) {
			if (filters[key]) {
				parameters = parameters.append(key, filters[key]);
			}
		}

		return this.http.post<genericFormI>(this.postTaskCustomFieldUrl, data, { headers: headers, params: parameters });
	}

	updateTaskCustomField(filters: object, data: genericFormI): Observable<genericFormI> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		let parameters = new HttpParams();

		for (const key of Object.keys(filters)) {
			if (filters[key]) {
				parameters = parameters.append(key, filters[key]);
			}
		}

		return this.http.put<genericFormI>(this.putTaskCustomFieldUrl, data, { headers: headers, params: parameters });
	}

	deleteTaskCustomField(filters: object): Observable<genericFormI[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		let parameters = new HttpParams();

		for (const key of Object.keys(filters)) {
			if (filters[key]) {
				parameters = parameters.append(key, filters[key]);
			}
		}

		return this.http.delete<genericFormI[]>(this.deleteTaskCustomFieldUrl, { headers: headers, params: parameters });
	}

	getTaskCustomField(filters: object): Observable<genericFormI[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		let parameters = new HttpParams();

		for (const key of Object.keys(filters)) {
			if (filters[key]) {
				parameters = parameters.append(key, filters[key]);
			}
		}

		return this.http.get<genericFormI[]>(this.getTaskCustomFieldUrl, { headers: headers, params: parameters });
	}
}
